import { useSelector } from 'react-redux';
import { selectCourses } from '~/modules/applications/redux/applications.selectors';
import { CourseBlock } from '~/modules/applications/pages/Home/blocks/components/CourseBlock/CourseBlock';
import React, { createRef, useRef } from "react";

export const CoursesBlocks = (props) => {
  const courses = useSelector(selectCourses);
  // React ref to store array of refs
  const scrollRefs = useRef([]);
  // Populate scrollable refs, only create them once
  // if the selectedElements array length is expected to change there is a workaround
  scrollRefs.current = [...Array(courses.length).keys()].map(
    (_, i) => scrollRefs.current[i] ?? createRef()
  );

  return (
    <div>
      {/* <Collapse title='Courses' defaultExpanded={true}> */}
          <div className="courses-blocks">
              <div className="inner">
                  {courses.map((course, i) => (
                  <div
                  key={i}
                  ref={scrollRefs.current[i]} // <-- pass scroll ref @ index i
                  // style={{paddingTop : '25px'}}
                >
                <CourseBlock course={course} key={course.id} withButtons={props.withButtons} />
                <br></br>
                </div>
                ))}
              </div>
          </div>
      {/* </Collapse> */}
    </div>
  );
};
